<script>
export default {
  name: 'SchemaMetadata',
  description: 'Schema.org metadata in JSON-LD for SSR pages.',
  release: '0.2.2',
  functional: true,
  props: {
    schema: {
      type: Object,
      required: true
    }
  },
  render (h, { props }) {
    return h('script', {
      attrs: { type: 'application/ld+json' },
      domProps: {
        innerHTML: JSON.stringify(props.schema)
      }
    })
  }
}
</script>
